import React from 'react'
import { BreadcrumbsBox, BreadcrumbsItem } from './styles'

const Breadcrumbs = (props: any) => {
  return(
    <BreadcrumbsBox>
      <BreadcrumbsItem>Início</BreadcrumbsItem>
      <BreadcrumbsItem>/</BreadcrumbsItem>
      <BreadcrumbsItem active>Risco</BreadcrumbsItem>
    </BreadcrumbsBox>
  )
}

export { Breadcrumbs }